
import type { MaterialWithVariantInventory, SizeLike, VariantInventoryLike } from '../components/interfaces';


const normalizeSize = (value?: string | null) =>
  String(value || '').replace(/"/g, '').trim().toLowerCase();

const getSizeTokens = (size?: SizeLike | null) =>
  [size?.value, size?.label]
    .flatMap((rawValue) => String(rawValue || '').split(','))
    .map(normalizeSize)
    .filter(Boolean);

export const findVariantInventoryForSize = (
  variantInventories: VariantInventoryLike[] | null | undefined,
  selectedSize?: string | null,
  productId?: string | null
) => {
  const normalizedSelectedSize = normalizeSize(selectedSize);
  const rows = (variantInventories || []).filter((row) =>
    productId ? row.product?.id === productId : true
  );

  if (!normalizedSelectedSize) {
    return rows.find((row) => !row.size?.id) || null;
  }

  return rows.find((row) =>
    getSizeTokens(row.size).includes(normalizedSelectedSize)
  ) || null;
};

export const getVariantStockQuantity = (
  material: MaterialWithVariantInventory | null | undefined,
  selectedSize?: string | null,
  productId?: string | null
) => {
  const variants = material?.variantInventories;
  const variant = findVariantInventoryForSize(variants, selectedSize, productId);
  const hasVariantRows = Array.isArray(variants) && variants.length > 0;

  return typeof variant?.stockQuantity === 'number'
    ? variant.stockQuantity
    : hasVariantRows && selectedSize
      ? 0
    : material?.stockQuantity;
};

export const isVariantAvailable = (
  material: MaterialWithVariantInventory | null | undefined,
  selectedSize?: string | null,
  productId?: string | null
) => {
  const variants = material?.variantInventories;
  const variant = findVariantInventoryForSize(variants, selectedSize, productId);
  const hasVariantRows = Array.isArray(variants) && variants.length > 0;

  if (hasVariantRows && selectedSize && !variant) {
    return false;
  }

  return material?.isAvailable !== false && variant?.isAvailable !== false;
};
